import $ from 'jquery';
import {formatPrice} from '@utils/commonUtils.js';
import priceCalculationService from '../services/priceCalculationService';

/**
 * @typedef {'flight'|'hotel'|'ticket'} PackageType
 */

/**
 * @param {PackageType} packageType
 */
const updateTicketCategoryPrices = (packageType) => {
    $('.package-price-flight, .package-price-hotel, .package-price-ticket').addClass('d-none');
    $(`.package-price-${packageType}`).removeClass('d-none');
},

/**
 * Update package type selector prices based on selected arrangement
 * @param {Object} arrangement
 */
 updatePackageTypeSelectorPrices = (arrangement) => {
    const calculatedPrices = priceCalculationService.calculatePackagePrices(arrangement),
     $flightPrice = $('.package-type-row[data-package-type="flight"] .price-value'),
     $hotelPrice = $('.package-type-row[data-package-type="hotel"] .price-value'),
     $ticketPrice = $('.package-type-row[data-package-type="ticket"] .price-value');
    
    if ($flightPrice.length) {
        $flightPrice.text(formatPrice(calculatedPrices.flight));
    }

    if ($hotelPrice.length) {
        $hotelPrice.text(formatPrice(calculatedPrices.hotel));
    }

    if ($ticketPrice.length) {
        $ticketPrice.text(formatPrice(calculatedPrices.ticket));
    }
},

/**
 * Sync the package type selector with the selected widget package
 * @param {PackageType} packageType
 */
 syncPackageTypeSelector = (packageType) => {
    $('.package-type-row').removeClass('active');
    $(`.package-type-radio-input[value="${packageType}"]`).prop('checked', true);
    
    updateTicketCategoryPrices(packageType);
};

export {
    updateTicketCategoryPrices,
    updatePackageTypeSelectorPrices,
    syncPackageTypeSelector
};